module.exports = __webpack_public_path__ + "static/media/review-image-helmis.c7d8e17b.png";